module.exports = __webpack_public_path__ + "static/media/add_blue.5dccd3df.svg";